var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWxUsdcusdnTci(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 330,
    viewBox: "0 0 330 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M229.378 196.885C210.892 186.228 173.652 164.743 173.652 164.743C173.652 164.743 247.776 121.906 284.721 100.564L284.794 100.61L284.877 100.663C266.618 132.284 229.378 196.885 229.378 196.885Z",
    fill: "#E04A50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5525 91.2017C43.4805 87.7212 49.7245 84.1391 55.1772 81.0018C55.125 128.42 55.0728 175.841 55.0209 223.262C49.3534 226.535 37.5525 233.082 37.5525 233.082V91.2017Z",
    fill: "#5980E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9849 75.8833C78.5153 67.4898 108.039 50.6838 108.039 50.6838C108.033 98.0344 108.027 145.388 108.02 192.739C93.6527 201.022 63.8286 218.003 63.8286 218.003C63.8838 168.573 63.9297 126.568 63.9849 75.8833Z",
    fill: "#2775CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.85 45.3598C131.38 36.9723 145.91 28.5847 160.44 20.1973C160.493 67.5019 160.545 114.806 160.597 162.108L116.696 187.676C116.745 140.236 116.798 92.7996 116.85 45.3598Z",
    fill: "#2775CA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M169.251 19.9206C182.535 28.6408 199.284 37.2811 213.305 45.3814C213.357 74.2026 213.412 103.027 213.461 131.851C199.207 140.089 169.251 157.361 169.251 157.361L169.251 19.9206Z",
    fill: "#04B494"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M222.116 50.6163L288.3 88.6747L222.131 126.908C222.131 101.478 222.116 76.0468 222.116 50.6163Z",
    fill: "#01FBB3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M160.597 309.135L42.1895 240.789L59.6456 230.764C59.6456 230.764 127.059 269.889 160.597 289.452V309.135Z",
    fill: "#E04A50"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M160.585 279.534L68.1803 225.612C68.1803 225.612 97.8419 208.444 112.4 200.038C112.4 200.038 144.91 219.101 160.597 228.264L160.585 279.534Z",
    fill: "#2775CA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M160.597 218.362L121.026 195.241C121.026 195.241 147.56 179.757 160.597 172.235V218.362Z",
    fill: "#2775CA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M169.251 172.164C188.759 183.195 224.894 204.408 224.894 204.408L169.251 300.603V172.164Z",
    fill: "#19202E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M176.878 304.893L232.518 208.668C250.999 219.331 288.201 240.81 288.201 240.81C288.201 240.81 177.105 304.814 176.878 304.893Z",
    fill: "#5980E9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M292.449 233.355C273.959 222.701 236.968 201.111 236.968 201.111C236.968 201.111 273.95 136.752 292.449 104.711C292.615 150.301 292.556 189.136 292.449 233.355Z",
    fill: "#19202E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWxUsdcusdnTci);
export default __webpack_public_path__ + "static/media/wxUSDCUSDN_TCI.bdcec0bd0ab74f548ff3e04460b42fe3.svg";
export { ForwardRef as ReactComponent };